import React from 'react'
import './News.css'

export default class News extends React.Component{
    render(){
        return(
            <>
            </>
        )
    }
}